import { render, staticRenderFns } from "./ListingMiniature.vue?vue&type=template&id=3c65353a&scoped=true&"
import script from "./ListingMiniature.vue?vue&type=script&lang=js&"
export * from "./ListingMiniature.vue?vue&type=script&lang=js&"
import style0 from "./ListingMiniature.vue?vue&type=style&index=0&id=3c65353a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c65353a",
  null
  
)

export default component.exports